function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-c4aa3744\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./WrapperPadded.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./WrapperPadded.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-c4aa3744\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./WrapperPadded.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c4aa3744",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/markup/WrapperPadded.vue
// module id = fc326ba85981c3b81867
// module chunks = 89